module.exports = __webpack_public_path__ + "3d0f1c712fe2fde7958e6142301e93c3.MP3";